import { atom } from "recoil"

import type { Recruit } from "interfaces/RecruitIF"

export const recruitsState = atom<Recruit[]>({
  key: "recruitsState",
  default: [],
})
